import * as task from "@/service/taskTemplate.js";
export default {
    namespaced: true,
    state: {
        rules: {
            task_name: [
                { required: true, message: "请输入任务名称", trigger: "blur" },
            ],
            task_type: [
                { required: true, message: "请选择模板类型", trigger: "change" },
            ],
            task_level: [
                { required: true, message: "请选择优先级", trigger: "change" },
            ],
        },
        getListData: {
            pageIndex: 1,
            pageSize: 10,
            task_name: "",
        },
        getAllListData: {
            pageIndex: 1,
            pageSize: 10,
            task_name: "",
            task_type: "",
        },
        total: 0,
        pageList: [],
        allTotal: 0,
        pageAllList: [],
        loading: false,
    },
    mutations: {
        setpageList(state, list) {
            state.pageList = list.list;
            state.total = list.total;
        },
        setpageAllList(state, list) {
            state.pageAllList = list.list;
            state.allTotal = list.total;
        },
        setListData(state, data) {
            for (var x in state.getListData) {
                for (var y in data) {
                    if (x == y) {
                        state.getListData[x] = data[y];
                    }
                }
            }
        },
        setAllListData(state, data) {
            for (var x in state.getAllListData) {
                for (var y in data) {
                    if (x == y) {
                        state.getAllListData[x] = data[y];
                    }
                }
            }
        },
        setLoading(state, type) {
            state.loading = type;
        },
    },
    actions: {
        // 获取任务列表
        getTaskListSto({ commit, state }, type) {
            if (type) {
                commit("setLoading", true);
                let getObj = task.getTaskListSer(state.getListData, type);
                getObj.then(({ data }) => {
                    if (data.status == 0) {
                        commit("setpageList", data.data);
                        commit("setLoading", false);
                    } else {
                        commit("setLoading", false);
                    }
                });
                getObj.catch((err) => {
                    console.log(err);

                    commit("setLoading", false);
                });
                return getObj;
            } else {
                return Promise.reject(false)
            }
        },
        // 获取全部任务
        getAllTaskListSto({ commit, state }) {
            commit("setLoading", true);
            let getObj = task.getAllTaskListSer(state.getAllListData);
            getObj.then(({ data }) => {
                if (data.status == 0) {
                    commit("setpageAllList", data.data);
                    commit("setLoading", false);
                } else {
                    commit("setLoading", false);
                }
            });
            getObj.catch((err) => {
                console.log(err);

                commit("setLoading", false);
            });
            return getObj;
        },
        //添加任务
        saveTaskSto({ commit }, datas) {
            return task.saveTaskSer(datas);
        },
        //删除任务
        deleteTaskSto({ commit }, datas) {
            return task.deleteTaskSer(datas);
        },
        //取消任务
        cancelTaskSto({ commit }, datas) {
            return task.cancelTaskSer(datas);
        },
        //重试任务
        retryTaskSto({ commit }, datas) {
            return task.retryTaskSer(datas);
        },
        // 获取任务详情
        getTaskSto({ commit }, datas) {
            return task.getTaskSer(datas);
        },
        //查询模板
        getTemplateSto({ commit }, datas) {
            return task.getTemplateSer(datas);
        },
        //查询任务详情
        getTaskDetailsSto({ commit }, datas) {
            return task.getTaskDetailsSer(datas);
        },
    },
};